import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import { h5PageCount } from 'ThreeTerminal_utils';
import InfoTitle from '../infoTitle';

class BigImg extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    onClick = (url, clickCount) => {
        h5PageCount([clickCount]);
        window.location.href = url;
    };

    render() {
        const { content } = this.props;

        const {
            doc_thumbnail,
            weburl,
            clickCount,
            comment_contents,
            share_url,
            isOnClickDocTitle,
            isCallNewApp,
            isComment,
            pageInfo,
            doc_name,
            sub_name,
            nickname,
        } = content;

        const infoTitleData = {
            comment_contents,
            share_url,
            isOnClickDocTitle,
            isCallNewApp,
            isComment,
            pageInfo,
            sub_name,
            nickname,
        };

        return (
            <React.Fragment>
                <InfoTitle content={infoTitleData} />
                <div className={styles.video_briefs} onClick={() => this.onClick(weburl, clickCount)}>
                    <p>
                        {sub_name && <span className={styles.source}>@{sub_name}: </span>}
                        {doc_name}
                    </p>
                    <div className={styles.video}>
                        <img src={formatImage(doc_thumbnail, 349, 196)} />
                        <div className={styles.videoBtn} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(BigImg);
